var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ContentSlotsDistributor', {
    attrs: {
      "slot-key": _vm.$parent.slotKey
    }
  }, [_c('h1', {
    attrs: {
      "id": "r-command-not-found-解决办法"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#r-command-not-found-解决办法"
    }
  }, [_vm._v("#")]), _vm._v(" \\r command not found 解决办法")]), _vm._v(" "), _c('p', [_vm._v("当我们执行shell脚本的时候提示'\\r': command not found，但是检查了很多次并没有发现什么问题。")]), _vm._v(" "), _c('p', [_vm._v("原因是windows下的换行符是\\r\\n，而linux下的换行符是\\n，所以只要执行下面的命令把\\r去掉就可以了。")]), _vm._v(" "), _c('div', {
    staticClass: "language-bash line-numbers-mode"
  }, [_c('pre', {
    pre: true,
    attrs: {
      "class": "language-bash"
    }
  }, [_c('code', [_c('span', {
    pre: true,
    attrs: {
      "class": "token comment"
    }
  }, [_vm._v("#转化为unix格式")]), _vm._v("\n"), _c('span', {
    pre: true,
    attrs: {
      "class": "token function"
    }
  }, [_vm._v("sed")]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token parameter variable"
    }
  }, [_vm._v("-i")]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token string"
    }
  }, [_vm._v("'s/\\r$//'")]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token operator"
    }
  }, [_vm._v("<")]), _vm._v("filename"), _c('span', {
    pre: true,
    attrs: {
      "class": "token operator"
    }
  }, [_vm._v(">")]), _vm._v(" \n")])]), _vm._v(" "), _c('div', {
    staticClass: "line-numbers-wrapper"
  }, [_c('span', {
    staticClass: "line-number"
  }, [_vm._v("1")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("2")]), _c('br')])]), _c('p', [_vm._v("附：# "), _c('a', {
    attrs: {
      "href": "http://www.cnblogs.com/huai371720876/p/4738886.html",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("Linux中使用sed命令替换字符串小结"), _c('OutboundLink')], 1), _vm._v("\nsed替换的基本语法为:")]), _vm._v(" "), _c('p', [_vm._v("sed 's/原字符串/替换字符串/'")]), _vm._v(" "), _c('p', [_vm._v("单引号里面,s表示替换,三根斜线中间是替换的样式,特殊字符需要使用反斜线”\\”进行转义,但是单引号”‘”是没有办法用反斜线”\\”转义的,这时候只要把命令中的单引号改为双引号就行了,例如:")]), _vm._v(" "), _c('p', [_vm._v("sed \"s/原字符串包含'/替换字符串包含'/\" //要处理的字符包含单引号")]), _vm._v(" "), _c('p', [_vm._v("命令中的三根斜线分隔符可以换成别的符号,这在要替换的内容有较多斜线是较为方便,只需要紧跟s定义即可,例如换成问号”?”:")]), _vm._v(" "), _c('p', [_vm._v("sed 's?原字符串?替换字符串?' //自定义分隔符为问号")]), _vm._v(" "), _c('p', [_vm._v("可以在末尾加g替换每一个匹配的关键字,否则只替换每行的第一个,例如:")]), _vm._v(" "), _c('p', [_vm._v("sed 's/原字符串/替换字符串/' //替换所有匹配关键字")]), _vm._v(" "), _c('p', [_vm._v("上箭头”^”表示行首,美元”$”符号如果在引号中表示行尾,但是在引号外却表示末行(最后一行),这里犯二了,搜了半天哪个符号表示首行,半天才想起来,首行就是数字”1″啊.那么在行首和行尾添加字符串就是把行尾和行首替换,例如:")]), _vm._v(" "), _c('p', [_vm._v("sed 's/^/添加的头部&/g' //在所有行首添加\nsed 's/$/&添加的尾部/g' //在所有行末添加\nsed '2s/原字符串/替换字符串/g' //替换第2行\nsed '$s/原字符串/替换字符串/g' //替换最后一行\nsed '2,5s/原字符串/替换字符串/g' //替换2到5行\nsed '2,$s/原字符串/替换字符串/g' //替换2到最后一行")]), _vm._v(" "), _c('p', [_vm._v("替换样式可以多个在同一条命令中执行,用分号”;”分隔,例如:")]), _vm._v(" "), _c('p', [_vm._v("sed 's/^/添加的头部&/g；s/$/&添加的尾部/g' //同时执行两个替换规则")]), _vm._v(" "), _c('p', [_vm._v("sed处理过的输出是直接输出到屏幕上的,要保存可以将输出重定向,或者使用参数”i”直接在文件中替换:")]), _vm._v(" "), _c('p', [_vm._v("sed -i 's/原字符串/替换字符串/g' filename //替换文件中的所有匹配项")])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };